import { Box } from "@mui/material";
import { GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { TbArrowsMaximize, TbArrowsMinimize, TbRefresh, TbUserX } from "react-icons/tb";

import FilterButton from "@/components/table/FilterButton";
import { useUsersTableActions, useUsersTableFilters, useUsersTableIsFullScreen } from "@/stores/use-users-table";

const UserToolbar = memo(function CustomToolbar({ reloadTable }: { reloadTable: () => void }) {
    const { t } = useTranslation();

    const { updateFullScreen, updateFilters } = useUsersTableActions();
    const isFullScreen = useUsersTableIsFullScreen();
    const filters = useUsersTableFilters();

    const handleIsDeletedFilter = () => {
        updateFilters({ isDeleted: !filters.isDeleted });
    };

    return (
        <GridToolbarContainer className=" !flex !flex-nowrap !items-center !px-2 !py-1 !gap-1">
            <GridToolbarQuickFilter placeholder={t("search") + " ..."} />
            <Box sx={{ flexGrow: 1 }} />

            <FilterButton
                active={filters.isDeleted}
                handleClick={handleIsDeletedFilter}
                icon={TbUserX}
                tooltip={t("tooltips.hideDeletedUsers", { count: filters.isDeleted ? 2 : 1 })}
            />

            <FilterButton handleClick={() => reloadTable()} icon={TbRefresh} tooltip={t("tooltips.refreshTable")} />
            <FilterButton
                active={isFullScreen}
                handleClick={() => updateFullScreen()}
                tooltip={t("tooltips.fulscreen", { count: isFullScreen ? 2 : 1 })}
                icon={isFullScreen ? TbArrowsMinimize : TbArrowsMaximize}
            />
        </GridToolbarContainer>
    );
});

export default UserToolbar;
